<template>
  <div class="wrapper">
    <div class="header">
      <img v-on:click="back()" :src="icon" class="icon" />
      <p class="title">{{ this.$store.getters.TRANSLATIONS["reset_code"] }}</p>
    </div>
    <div class="content">
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["enter_code"] }}
      </p>
      <input
        type="text"
        v-model="code"
        placeholder
        class="code"
        autocomplete="off"
      />
    </div>
    <div class="footer">
      <button v-on:click="doReset()" class="button">
        {{ this.$store.getters.TRANSLATIONS["next"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: "",
      doReset: () => {
        if (this.code == this.$store.getters.RESET_PASS_CODE) {
          this.$router.push("/newPassword");
        } else {
          this.$modal.show("dialog", {
            text: this.$store.getters.TRANSLATIONS["not_valid_code"],
            buttons: [
              {
                title: "OK",
                handler: () => {
                  this.$router.push("/login");
                }
              }
            ]
          });
        }
      },
      back: () => {
        this.$router.push("/forgotPassword");
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/ForgotPasswordCode.vue